<template>
  <sTooltip
    :border="false"
    :content="value"
    :disabled="!isNeedTooltip"
    :open-delay="300"
    placement="bottom"
    popper-class="all-text-tooltip"
    type="white"
    @focus="$emit('focus')">
    <component
      :is="tag"
      data-qa="tooltip-in-row"
      :style="style">
      <component
        :is="componentType"
        ref="TooltipedText"
        style="word-wrap: break-word;"
        v-bind="componentParams">
        {{ value }}
      </component>
    </component>
  </sTooltip>
</template>

<script>
/**
* Сворачивание текста по количеству строк
* @category components
* @vue-prop {String} value - Текст (в случае url его описание)
* @vue-prop {String} [tag='span'] - Тип эллемента
* @vue-prop {Boolean} [showTooltip=true] - Отобразить компонент разворота текста
* @vue-prop {Boolean} [textIsUrl=false] - Отобразить текст как ссылку
* @vue-prop {Object} [routeParams] - Параметры для router-link
* @vue-prop {String} url - Текст
* @vue-prop {Number} lineCount - Максимальное количество строк текста
* @vue-prop {Number} [lineHeight=1] - Высота строк текста
*/

import { eventBus } from '@/main'

export default {
  name: 'tooltipedTextLineCount',
  props: {
    value: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: 'span',
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
    textIsUrl: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    lineCount: {
      type: Number,
      required: true,
    },
    lineHeight: {
      type: Number,
      default: 1,
    },
    routeParams: {
      type: Object,
    },
    innerStyle: {
      type: Object,
    },
  },
  data() {
    return {
      isNeedTooltip: false,
    }
  },
  computed: {
    componentType() {
      if (this.textIsUrl) { return 'a' }
      if (this.routeParams) { return 'router-link' }
      return 'span'
    },
    componentParams() {
      if (this.routeParams) {
        return this.routeParams
      } else if (this.textIsUrl) {
        return { href: this.url }
      }
      return {}
    },
    style() {
      const maxHeight = Math.round((this.lineCount + 0.4) * this.lineHeight * 100) / 100
      return {
        ...this.innerStyle,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        webkitBoxOrient: 'vertical',
        webkitLineClamp: this.lineCount,
        lineHeight: this.lineHeight + ' !important',
        maxHeight: `${maxHeight}em`,
      }
    },
  },
  methods: {
    checkNeedShowTooltip() {
      if (!this.showTooltip) {
        this.isNeedTooltip = false
        return
      }
      const el = this.routeParams ? this.$refs.TooltipedText.$el : this.$refs.TooltipedText
      if (!el) {
        this.isNeedTooltip = false
        return
      }
      const height = this.routeParams ? el.scrollHeight : el.offsetHeight
      const lines = height / parseInt(window.getComputedStyle(el).fontSize, 10)
      this.isNeedTooltip = Math.floor(lines) > this.lineCount
    }
  },
  mounted() {
    if (this.showTooltip) {
      this.checkNeedShowTooltip()
      if (this.$root.$eventBus) {
        this.$root.$eventBus.$on('resizeWindow', this.checkNeedShowTooltip)
      } else if (typeof eventBus !== 'undefined') {
        eventBus.$on('resizeWindow', this.checkNeedShowTooltip)
      }
    }
  },
  beforeDestroy() {
    if (this.showTooltip) {
      if (this.$root.$eventBus) {
        this.$root.$eventBus.$off('resizeWindow', this.checkNeedShowTooltip)
      } else if (typeof eventBus !== 'undefined') {
        eventBus.$off('resizeWindow', this.checkNeedShowTooltip)
      }
    }
  },
}
</script>
